import { QueryClient } from '@tanstack/react-query';

import { ADDRESS_BOOK_BFF_QUERY_KEYS } from '../address-book-bff/queries';
import { ADDRESS_BOOK_QUERY_KEYS } from './queries';

/** The dashboard keeps `AddressBookTable` mounted behind every modal, so its `refetchOnMount` never
 * re-fires when one closes — anything that writes contacts server-side has to invalidate by hand. */
export const invalidateAddressBookLists = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: [ADDRESS_BOOK_BFF_QUERY_KEYS.contacts] });
  queryClient.invalidateQueries({ queryKey: [ADDRESS_BOOK_QUERY_KEYS.categories] });
};
